import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Footer } from "@/components/Footer";

export const PolicyLayout = ({ title, updated, testId, children }) => (
  <div className="min-h-screen bg-[#08090E]">
    <header className="sticky top-0 z-40 border-b border-[#1E2433]/80 bg-[#08090E]/85 backdrop-blur-xl">
      <div className="mx-auto flex max-w-4xl items-center gap-3 px-4 py-3 sm:px-8">
        <Link to="/" data-testid="policy-back" className="flex items-center gap-1.5 text-sm text-slate-400 transition-colors hover:text-emerald-400">
          <ArrowLeft className="h-4 w-4" /> Store
        </Link>
      </div>
    </header>

    <main data-testid={testId} className="mx-auto max-w-4xl px-4 py-10 sm:px-8">
      <h1 className="font-display text-4xl font-extrabold tracking-tight text-slate-100 sm:text-5xl">{title}</h1>
      {updated && <p className="mt-2 font-mono text-xs uppercase tracking-widest text-slate-500">Last updated: {updated}</p>}
      <div className="prose-invert mt-8 space-y-6 text-sm leading-relaxed text-slate-300 [&_h2]:mt-8 [&_h2]:font-display [&_h2]:text-xl [&_h2]:font-bold [&_h2]:text-slate-100 [&_a]:text-emerald-400 [&_li]:mb-1 [&_ul]:list-disc [&_ul]:pl-5">
        {children}
      </div>
    </main>
    <Footer />
  </div>
);
